import Button from "components/BaseWidgets/button";
import React from "react";

function FooterButton({
  onSave,
  primaryLabel = "Save",
  isLoading,
  isDisabled,
  onCancel,
  secondaryLabel = "Cancel",
  secondaryBtn = false,
}) {
  const handleScroll = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="flex items-center justify-end gap-3 mt-2">
      {secondaryBtn && (
        <Button
          height={44}
          onClick={(val) => {
            handleScroll();
            if (onCancel) {
              onCancel(val);
            }
          }}
          variant="secondary"
        >
          {secondaryLabel}
        </Button>
      )}
      <Button
        height={44}
        onClick={(val) => {
          handleScroll();
          if (onSave) {
            onSave(val);
          }
        }}
        isLoading={isLoading}
        isDisabled={isDisabled}
      >
        {primaryLabel}
      </Button>
    </div>
  );
}

export default FooterButton;
